import { ethers } from 'ethers';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

const DEFAULT_GAS_LIMIT = '21000';

export function useProvider(): [
  ethers.providers.Web3Provider | null,
  Dispatch<SetStateAction<ethers.providers.Web3Provider | null>>
] {
  const [provider, setProvider] =
    useState<ethers.providers.Web3Provider | null>(null);
  const created = useRef(false);

  async function createProvider() {
    if (created.current) return;

    created.current = true;
    const provider = new ethers.providers.Web3Provider(
      (window as any).ethereum
    );
    await provider.send('eth_requestAccounts', []);

    setProvider(provider);
  }

  useEffect(() => {
    createProvider();
  }, []);

  return [provider, setProvider];
}

export async function sendTransaction(
  provider: ethers.providers.Web3Provider | null,
  payload: {
    to: string;
    value: string;
    nonce?: string;
    maxFeePerGas?: string;
    maxPriorityFeePerGas?: string;
  }
): Promise<ethers.providers.TransactionReceipt | false> {
  if (!provider) return false;

  const { value, to, nonce, maxFeePerGas, maxPriorityFeePerGas } = payload;
  const transaction: ethers.providers.TransactionRequest = {
    to,
    value: ethers.utils.parseEther(value),
    nonce,
    type: 2,
    gasLimit: DEFAULT_GAS_LIMIT,
    maxFeePerGas,
    maxPriorityFeePerGas,
  };

  const signer = provider.getSigner();

  const response = await signer.sendTransaction(transaction);

  const receipt = await response.wait();

  return receipt;
}
